import { useMutationWithRefresh } from '../useMutationWithRefresh';
import rentalService, { RentalForm } from '../../services/rentalService';
import { queryKeys } from '../../queryClient';
import { showAlert } from '../../utils/alert';

// สร้างการเช่า
export const useCreateRental = () => {
  return useMutationWithRefresh({
    mutationFn: (data: RentalForm) => rentalService.createRental(data),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.all, // อัพเดทสถานะอุปกรณ์
      queryKeys.sims.all, // อัพเดทสถานะซิม
      queryKeys.dashboard.summary, // อัพเดทสถิติ
      queryKeys.dashboard.revenue, // อัพเดทรายได้
    ],
    successMessage: 'สร้างการเช่าสำเร็จ',
  });
};

// แก้ไขการเช่า
export const useUpdateRental = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data }: { id: number; data: Partial<RentalForm> }) => 
      rentalService.updateRental(id, data),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.all,
      queryKeys.sims.all,
      queryKeys.contracts.all, // contracts อ้างอิงการเช่า
      queryKeys.reports.all, // reports ใช้ข้อมูลการเช่า
    ],
    successMessage: 'แก้ไขการเช่าสำเร็จ',
  });
};

// เปลี่ยนสถานะการเช่า
export const useUpdateRentalStatus = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, status }: { id: number; status: string }) => 
      rentalService.updateRentalStatus(id, status),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.available, // อัพเดทอุปกรณ์ที่ว่าง
      queryKeys.sims.available, // อัพเดทซิมที่ว่าง
      queryKeys.dashboard.all, // อัพเดท dashboard ทั้งหมด
    ],
    successMessage: 'เปลี่ยนสถานะการเช่าสำเร็จ',
  });
};

// อนุมัติ/ปฏิเสธการเช่า (DRAFT → ACTIVE หรือ CANCELLED)
export const useApproveRental = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, approved = true, notes }: { id: number; approved?: boolean; notes?: string }) =>
      rentalService.approveRental(id, approved, notes),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.available, // อนุมัติ → reserve อุปกรณ์
      queryKeys.sims.available,
      queryKeys.dashboard.all,
    ],
    successMessage: 'อนุมัติการเช่าสำเร็จ — เริ่มใช้งานแล้ว',
  });
};

// อัพเดทสถานะหลายรายการ
export const useBulkUpdateRentalStatus = () => {
  return useMutationWithRefresh({
    mutationFn: ({ ids, status }: { ids: number[]; status: string }) => 
      rentalService.bulkUpdateStatus(ids, status),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.all,
      queryKeys.sims.all,
      queryKeys.dashboard.all,
    ],
    onSuccessCallback: (data: any) => {
      // แสดงจำนวนที่อัพเดทสำเร็จ
      if (data.updated_count) {
        showAlert('สำเร็จ', `อัพเดทสถานะสำเร็จ ${data.updated_count} รายการ`, 'success');
      } else {
        showAlert('สำเร็จ', 'อัพเดทสถานะสำเร็จ', 'success');
      }
    },
  });
};

// ลบการเช่า
export const useDeleteRental = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => rentalService.deleteRental(id),
    invalidateKeys: [
      queryKeys.rentals.all,
      queryKeys.devices.all, // คืนสถานะอุปกรณ์
      queryKeys.sims.all, // คืนสถานะซิม
      queryKeys.dashboard.summary,
    ],
    successMessage: 'ลบการเช่าสำเร็จ',
    errorMessage: 'ไม่สามารถลบการเช่าได้ อาจมีสัญญาที่เกี่ยวข้อง',
  });
};